import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { logPageView } from '../lib/analytics'
import { ANALYTICS_CONSENT_GRANTED_EVENT } from '../lib/marketing'

// GA4 does not auto-track page views in a single-page app: the page never
// reloads between routes, so only the very first load would ever be counted.
// This listener fires a page_view on the initial mount and on every subsequent
// route change so analytics reflects real navigation. Renders nothing; it must
// live inside <BrowserRouter> to use useLocation.
export function RouteAnalytics() {
  const location = useLocation()

  useEffect(() => {
    logPageView(location.pathname + location.search)
  }, [location.pathname, location.search])

  useEffect(() => {
    const logCurrentPage = () => logPageView(location.pathname + location.search)
    window.addEventListener(ANALYTICS_CONSENT_GRANTED_EVENT, logCurrentPage)
    return () => window.removeEventListener(ANALYTICS_CONSENT_GRANTED_EVENT, logCurrentPage)
  }, [location.pathname, location.search])

  return null
}
